module.exports = __webpack_public_path__ + "static/media/DSCF9888-2.0bea5419.jpg";